import React, { useCallback, useState } from "react";

import Portal from "../../components/shared/portal";
import { FilterMenu } from "../find-program-page/filterMenu";

export const FilterMenuContainer = ({
  className,
  filterMenuCTAClass = "",
  filterOptions,
  filterPrograms,
  filterHeading = "Filter programs"
}) => {
  const [openSidebar, setOpenSidebar] = useState(false);

  const handleOpenSidebar = useCallback(() => {
    setOpenSidebar(true);
  }, []);

  const handleCloseSidebar = useCallback(() => {
    setOpenSidebar(false);
  }, []);

  return (
    <>
      <button
        className={`flex justify-center gap-2 py-3 bg-yellow-standard/20 planet:bg-gray-darker w-full border-0.5 border-gray-testimonial backdrop-blur-lg ${className} ${filterMenuCTAClass}`}
        onClick={handleOpenSidebar}
      >
        <h6
          className="font-bold text-white"
          dangerouslySetInnerHTML={{ __html: filterHeading }}
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-4 h-4 mt-1 stroke-white"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z"
          />
        </svg>
      </button>
      <Portal>
        <FilterMenu
          options={filterOptions}
          openSidebar={openSidebar}
          handleCloseSidebar={handleCloseSidebar}
          className="block md:hidden"
          filterPrograms={filterPrograms}
        />
      </Portal>
    </>
  );
};
